import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { LevelsStateTranslatePipe } from 'src/app/core/pipes/levels-state-translate.pipe';
import { BadgeCount } from '../badge-container/badge-container.model';

@Component({
  selector: 'filter-badge',
  templateUrl: './filter-badge.component.html',
  styleUrls: ['./filter-badge.component.sass'],
  standalone: true,
  imports: [CommonModule, LevelsStateTranslatePipe]
})
export class FilterBadgeComponent implements OnInit, OnChanges {
  @Input() isMonitoringPoints? = false;
  @Input() title = '';
  @Input() active = false;
  @Input() count: BadgeCount | number = 0;
  @Input() showFilterCount = true;
  @Input() showIcon = true;
  src = '';

  ngOnInit(): void {
    if (this.title === 'acknowledged') {
      this.title = 'acknow';
    }

    if (this.title === 'in progress') {
      this.title = 'in-progress';
    }

    if (this.title === 'ca review') {
      this.title = 'ca-review';
    }

    if (this.isMonitoringPoints && this.title === 'info') {
      this.title = 'clear';
    }

    this.handleImageSrc();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.handleImageSrc();
  }

  handleImageSrc() {
    this.src = `assets/icons/${this.title}-icon.svg`;
  }

  handleClass(active: boolean) {
    return {
      [this.title]: true,
      active: active,
      'filter-badge': true,
      'no-count': !this.showFilterCount
    };
  }
}
